export { default } from './BackgroundImageRenderer'
